module.exports = __webpack_public_path__ + "static/media/(V)-Artesanato-01.723defb8.jpg";